import React from 'react';
import { Typography } from '@mui/material';
import { useAuditScoreColor } from 'modules/audit/management/hooks/useAuditScoreColor';
import { ServiceType } from 'modules/settings/templates/main/interfaces';

export interface Props {
  number?: number;
  serviceType?: ServiceType;
  label?: string;
}

const SurveyRateCell = ({ number, serviceType, label }: Props) => {
  const validNumber = number != null;
  const color = useAuditScoreColor(number, serviceType);

  return (
    <>
      {label && validNumber && <span className={'text-gray-500 mr-1'}>{label}</span>}
      {validNumber ? (
        <Typography color={color} sx={{ fontWeight: 'bold', fontSize: '20px' }}>
          {Number(number.toFixed(2))}%
        </Typography>
      ) : (
        <strong> - </strong>
      )}
    </>
  );
};

export default SurveyRateCell;
